import React, { useCallback, useRef, useEffect, useState } from "react";
import { StyleSheet, View }                                from "react-native";
import palette                                             from "~/styles/palette";
import CardHeader                                          from "~/components/ExpandableCard/CardHeader"

export default function ExpandableCard({
  title,
  icon = "info",
  openOnMount = false,
  badge,
  onOpen,
  onClose,
  children,
}) {
  let isMounted = useRef(false).current;
  const [open, setOpen] = useState(openOnMount);
  const [openHeight, setHeight] = useState(60);

  const onToggleOpen = useCallback(() => {
    if (badge === 0) return setOpen(false);
    if (badge === false) return;
    if (onOpen && !open) onOpen();
    setOpen(!open);
    if (onClose && open) onClose();
  }, [badge, open, setOpen, onOpen, onClose]);

  const onLayout = useCallback(
    (e) => {
      if (isMounted) setHeight(e.nativeEvent?.layout?.height + 85 || 320);
    },
    [setHeight]
  );

  useEffect(() => {
    isMounted = true;
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <View
      style={[
        styles.expandable_card__container,
        { height: open ? openHeight : 60 },
      ]}
    >
      <CardHeader
        title={title}
        iconName={icon}
        open={open}
        badge={(badge === true || badge === false) ? undefined : badge}
        onToggleOpen={onToggleOpen}
        expandable={!!badge}
      />
      <View onLayout={onLayout}>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  expandable_card__container: {
    fontWeight: "500",
    color: palette.grey,
    paddingHorizontal: 16,
    // borderColor: palette.lighter_grey,
    // borderBottomWidth: 1,
    borderRadius: 12,
    backgroundColor: palette.white,
    overflow: "hidden",
    transitionDuration: "150ms",
    transitionProperty: "all",
    transitionTimingFunction: "ease-out",
    minHeight: 60,
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.05,
    shadowRadius: 9.62,
    elevation: 4,
  },
});
